import Vue from 'vue'

import qs from 'qs'
import { assert } from '@core/assert'
import axios from '@axios'

import { successNotification, errorNotification } from "@/auth/utils";
import { ResponseWrapper, ErrorWrapper } from './util'

export class BaseService {

  setup () {
    return {
      successNotification,
      errorNotification,
    };
  }


  static get entity () {
    throw new Error('entity getter not defined')
  }
  /**
   * ------------------------------
   * @HELPERS
   * ------------------------------
   */

  static request (status = { auth: false }) {
    return new Http(status)
  }

  static responseWrapper (...rest) {
    return new ResponseWrapper(...rest)
  }

  static errorWrapper (...rest) {
    return new ErrorWrapper(...rest)
  }

  static querystring (obj) {
    return qs.stringify(obj, {
      encode: false
    })
  }

  /**
   * ------------------------------
   * @API_CALLS_PUBLIC
   * ------------------------------
   */

  static async findAll (parameters = {}) {
    // assert.object(parameters)

    const params = { ...parameters }

    try {
      const response = await axios.get(`${this.entity}/findAll`, { params })

      // NOT FOUND
      if (response.data.code == '06') {
        const message = response.data.message
        errorNotification(Vue, "Oops!", message);
        throw new ErrorWrapper(error, message)
      }

      const data = {
        content: response.data.data.content,
        total: Number(response.data.data.totalElements),
        totalPages: Number(response.data.data.totalPages)
      }

      return new ResponseWrapper(response, data)
    } catch (error) {
      const message = error.response.data ? error.response.data.message : error.response.statusText
      errorNotification(Vue, "Oops!", message);

      throw new ErrorWrapper(error, message)
    }
  }

  static async All (parameters = {}) {
    // assert.object(parameters)

    const params = { ...parameters }

    try {
      const response = await axios.get(`${this.entity}/all`, { params })

      // NOT FOUND
      if (response.data.code == '06') {
        const message = response.data.message
        errorNotification(Vue, "Oops!", message);
        throw new ErrorWrapper(error, message)
      }

      let content = response.data.data.content;
      if (content === undefined) {
        content   = response.data.data;
      }
      const data = {
        content: content,
        total: Number(response.data.data.totalElements)
      }

      return new ResponseWrapper(response, data)
    } catch (error) {
      const message = error.response.data ? error.response.data.message : error.response.statusText
      errorNotification(Vue, "Oops!", message);

      throw new ErrorWrapper(error, message)
    }
  }

  /**
   * ------------------------------
   * @API_CALLS_PUBLIC
   * ------------------------------
   */

  static async find (parameters = {}) {
    // assert.object(parameters)

    const params = { ...parameters }

    try {
      const response = await axios.get(`${this.entity}`, { params })

      // NOT FOUND
      // window.console.log(response.data.data);
      if (response.data.data === undefined) {
        const message = response.data.message;
        return  errorNotification(Vue, "Oops!", message);
      }
      if (response.data.data !== undefined) {
        const data = {
          content: response.data.data.content,
          total: Number(response.data.data.totalElements)
        }

        return new ResponseWrapper(response, data)
      }
    } catch (error) {
      const message = error.response.data ? error.response.data.message : error.response.statusText
      errorNotification(Vue, "Oops!", message);

      throw new ErrorWrapper(error, message)
    }
  }

  static async findSpesifict (parameters = {}) {
    // assert.object(parameters)

    const params = { ...parameters }

    try {
      const response = await axios.get(`${this.entity}`, { params })

      // NOT FOUND
      if (response.data.code == '06') {
        const message = response.data.message
        errorNotification(Vue, "Oops!", message);
        throw new ErrorWrapper(error, message)
      }

      const data = {
        content: response.data.data,
        total: Number(response.data.data.totalElements)
      }

      return new ResponseWrapper(response, data)
    } catch (error) {
      const message = error.response.data ? error.response.data.message : error.response.statusText
      errorNotification(Vue, "Oops!", message);

      throw new ErrorWrapper(error, message)
    }
  }

  static async getByIdPublic (id) {
    // assert.id(id, { required: true })

    try {
      const response = await this.$http.get(`${this.entity}/${id}`)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  /**
   * ------------------------------
   * @API_CALLS_PRIVATE
   * ------------------------------
   */

  static async getById (id) {
    // assert.id(id, { required: true })

    try {
      const response = await this.request({ auth: true }).get(`${this.entity}/${id}`)
      window.console.log(response);
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }


  static async create (data = {}) {
    try {
      const response = await axios.post(`${this.entity}`, data, {
        headers: { "content-type": "application/json" },
      })

      if (response.data.code == '02') {
        const message = response.data.message
        throw message
      }

      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      window.console.log(error);
      const message = error
      throw new ErrorWrapper(error, message)
    }
  }

  static async update (id, data = {}) {

    try {
      const response = await axios.put(`${this.entity}/${id}`, data, {
        headers: { "content-type": "application/json" },
      })

      if (response.data.code == '02') {
        const message = response.data.message
        throw message
      }

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      const message = error
      throw new ErrorWrapper(error, message)
    }
  }

  static async delete (id) {
    try {
      const response = await axios.delete(`${this.entity}/${id}`)

      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}
